import { computed } from 'vue'
import { useRoute } from 'nuxt/app'

import { resolveCpBreadcrumbRegistryKey } from '@common/navigation-layer/config/cp-breadcrumb-registry'

import { useAuth } from '@common/auth-layer/composables/useAuth'
import { useEventsQueryStore } from '../stores/events.query-store'
import { firstRouteValue } from '../utils/event-detail.utils'

/** The event name as the last breadcrumb segment on the event detail page; shares the page's cached detail query. */
export const useEventsDetailBreadcrumbLabel = () => {
  const route = useRoute()
  const auth = useAuth()
  const contactId = computed(() => (typeof auth.store.contactId === 'string' ? auth.store.contactId.trim() || null : null))
  // The exhibitor center sits under the event, so its crumb names the event too.
  const eventId = computed(() => {
    const key = resolveCpBreadcrumbRegistryKey(route)
    if (key !== 'clientportal-events-detail' && key !== 'clientportal-exhibitor-center') return undefined
    return firstRouteValue(route.params.eventId) || undefined
  })
  const detailQuery = useEventsQueryStore(contactId).fetchEventDetailQuery(eventId)

  return computed(() => (eventId.value ? detailQuery.data.value?.event?.name || undefined : undefined))
}
